module.exports = __webpack_public_path__ + "assets/img/windows-1.dd5ddd8a.jpg";